/* ===========================================================
   Po půlnoci — e-mailový popup

   Načítá se s defer, takže nezdržuje vykreslení stránky.
   Markup je v sections/pp-email-popup.liquid.

   Zápis jde přes {% form 'customer' %}, stejně jako přihlášení
   v patičce. Formulář odesílá prohlížeč nativně — přes fetch ho
   Shopify odmítalo. Tlačítko je type="button", takže odejít může
   jedině přes send(), tedy až po kontrole e-mailu i souhlasu.
   Potvrzení se ukazuje až po přenačtení, podle příznaku v sessionStorage.
   =========================================================== */

(function () {
  var root = document.querySelector('[data-pp-popup]');
  if (!root) return;

  var COOKIE = root.dataset.cookie || 'pp_popup_seen';
  var DAYS = parseInt(root.dataset.days, 10) || 30;
  var DELAY = parseInt(root.dataset.delay, 10);
  var DELAY_MOBILE = parseInt(root.dataset.delayMobile, 10);
  var EXIT_INTENT = root.dataset.exitIntent === 'true';
  var AUTOCLOSE = parseInt(root.dataset.autoclose, 10);

  /* ---- Paměť ---- */

  function alreadySeen() {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(COOKIE + '=') === 0;
    });
  }

  function remember() {
    document.cookie =
      COOKIE + '=1; path=/; max-age=' + DAYS * 86400 + '; SameSite=Lax';
  }

  var SENT_KEY = 'pp_popup_sent';

  function sentFlag(set) {
    try {
      if (set === true) sessionStorage.setItem(SENT_KEY, '1');
      else if (set === false) sessionStorage.removeItem(SENT_KEY);
      else return sessionStorage.getItem(SENT_KEY) === '1';
    } catch (e) {
      /* privátní režim */
    }
    return false;
  }

  // Odeslání přenačte stránku, takže potvrzení musíme ukázat až potom.
  // Příznak čteme dřív než cookie — jinak by nás vlastní zápis odstřihl.
  var justSent = sentFlag();
  if (justSent) sentFlag(false);

  // Zavřený popup nesmí nic blokovat — když se neukáže, skript končí
  // tady a na stránce po něm nezůstane žádný posluchač.
  if (!justSent && alreadySeen()) return;

  /* ---- Prvky ---- */

  var box = root.querySelector('[data-pp-box]');
  var overlay = root.querySelector('[data-pp-overlay]');
  var form = root.querySelector('form');
  var email = root.querySelector('[data-pp-email]');
  var emailErr = root.querySelector('[data-pp-email-err]');
  var consent = root.querySelector('[data-pp-consent]');
  var consentErr = root.querySelector('[data-pp-consent-err]');
  var formErr = root.querySelector('[data-pp-form-err]');
  var submit = root.querySelector('[data-pp-submit]');
  var submitLabel = root.querySelector('[data-pp-submit-label]');
  var panelForm = root.querySelector('[data-pp-panel="form"]');
  var panelDone = root.querySelector('[data-pp-panel="done"]');

  var isOpen = false;
  var pending = false;
  var lastFocus = null;
  var openTimer = null;
  var closeTimer = null;

  var FOCUSABLE =
    'button:not([disabled]), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---- Otevření a zavření ---- */

  // Otevřený košík (nebo jiný modal tématu) má přednost. Popup přes něj
  // nesmí skočit — počká, až ho člověk zavře, a teprve pak se ukáže.
  function blockedByDrawer() {
    if (document.querySelector('theme-drawer[open]')) return true;
    try {
      // Jen modální dialogy. Téma má i nemodální (náhled hotspotu),
      // a ten by popup zablokoval natrvalo.
      return Boolean(document.querySelector('dialog:modal'));
    } catch (e) {
      return Boolean(document.querySelector('dialog[open]'));
    }
  }

  function open(force) {
    if (isOpen) return;
    if (force !== true && alreadySeen()) return;

    if (force !== true && blockedByDrawer()) {
      pending = true;
      return;
    }
    pending = false;

    isOpen = true;
    clearTimeout(openTimer);
    document.removeEventListener('mouseout', onMouseOut);

    lastFocus = document.activeElement;
    root.hidden = false;
    // Vynutí si výpočet layoutu, jinak přechod nenaběhne.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var target = panelForm.hidden ? box : email;
    if (target) target.focus({ preventScroll: true });
    if (target === box) box.setAttribute('tabindex', '-1');
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(closeTimer);
    remember();

    root.classList.remove('is-open');
    document.body.style.overflow = '';

    var done = function () {
      root.hidden = true;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      done();
    } else {
      window.setTimeout(done, 280);
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  /* ---- Past na fokus ---- */

  function onKeydown(e) {
    if (!isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    var items = Array.prototype.filter.call(
      box.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      }
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('theme-drawer:close', function () {
    if (!pending) return;
    window.setTimeout(function () {
      if (pending && !blockedByDrawer()) open();
    }, 600);
  });

  document.addEventListener('keydown', onKeydown);
  overlay.addEventListener('click', close);
  Array.prototype.forEach.call(
    root.querySelectorAll('[data-pp-close]'),
    function (btn) {
      btn.addEventListener('click', close);
    }
  );

  /* ---- Spouštěče ---- */

  // Na dotykovém displeji není kam odjet myší, takže tam platí
  // jen prodleva — a delší, ať to nespadne do prvního scrollu.
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var delay = isTouch ? DELAY_MOBILE : DELAY;

  if (!isNaN(delay)) {
    openTimer = window.setTimeout(open, delay * 1000);
  }

  function onMouseOut(e) {
    // Kurzor musí opustit okno horem a nesmí přejít na jiný prvek.
    if (e.relatedTarget || e.clientY > 0) return;
    open();
  }

  if (EXIT_INTENT && !isTouch) {
    document.addEventListener('mouseout', onMouseOut);
  }

  /* ---- Validace ---- */

  function showErr(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function hideErr(el) {
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  function clearErrors() {
    hideErr(emailErr);
    hideErr(consentErr);
    hideErr(formErr);
    email.closest('.pp-popup__field').classList.remove('is-invalid');
    consent.closest('.pp-popup__consent').classList.remove('is-invalid');
  }

  // Záměrně mírnější než RFC — jde o překlepy, ne o pravost adresy.
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ---- Odeslání ---- */

  function showDone() {
    panelForm.hidden = true;
    panelDone.hidden = false;

    // Modal se pojmenovává podle nadpisu, a ten se teď vyměnil.
    var doneTitle = panelDone.querySelector('h2');
    if (doneTitle && doneTitle.id) {
      box.setAttribute('aria-labelledby', doneTitle.id);
    }

    box.setAttribute('tabindex', '-1');
    box.focus({ preventScroll: true });

    if (!isNaN(AUTOCLOSE) && AUTOCLOSE > 0) {
      closeTimer = window.setTimeout(close, AUTOCLOSE * 1000);
    }
  }

  // Formulář odešle prohlížeč sám, ale jedině odsud. Tlačítko je
  // type="button" a form.submit() se volá až za oběma kontrolami,
  // takže bez platného e-mailu a zaškrtnutého souhlasu neodejde nic.
  // form.submit() navíc nespouští posluchače na 'submit', takže do
  // toho nemá jak vstoupit ani obsluha tématu.
  function send() {
    if (submit.disabled) return;
    clearErrors();

    var value = email.value.trim();

    if (!EMAIL_RE.test(value)) {
      email.closest('.pp-popup__field').classList.add('is-invalid');
      showErr(emailErr, 'Zkontroluj prosím tvar e-mailu.');
      email.focus();
      return;
    }

    if (!consent.checked) {
      consent.closest('.pp-popup__consent').classList.add('is-invalid');
      showErr(consentErr, 'Bez souhlasu ti bohužel psát nemůžeme.');
      return;
    }

    submit.disabled = true;
    submitLabel.textContent = 'Posíláme…';

    sentFlag(true);
    form.submit();
  }

  submit.addEventListener('click', send);

  // Enter v poli se chová jako kliknutí.
  email.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    send();
  });

  // Pojistka: kdyby formulář přesto někdo odeslal jinudy, zastavíme to.
  form.addEventListener('submit', function (e) {
    if (!EMAIL_RE.test(email.value.trim()) || !consent.checked) {
      e.preventDefault();
      send();
    }
  });

  // Chyba zmizí, jakmile s polem něco uděláš — ať tam nesvítí zbytečně.
  email.addEventListener('input', function () {
    hideErr(emailErr);
    email.closest('.pp-popup__field').classList.remove('is-invalid');
  });

  consent.addEventListener('change', function () {
    hideErr(consentErr);
    consent.closest('.pp-popup__consent').classList.remove('is-invalid');
  });

  // Vracíme se z odeslání — rovnou potvrzení, žádná prodleva.
  if (justSent) {
    clearTimeout(openTimer);
    document.removeEventListener('mouseout', onMouseOut);
    // Zápis neprošel — popup neotvíráme vůbec a necháváme stránku být.
    if (formErr && formErr.textContent.trim() !== '') return;

    remember();
    open(true);
    showDone();
  }
})();
